const maxStepsList = {
  Hotel: 5,
  Individual: 7,
  Multiple: 8,
};

export default maxStepsList;
